import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCloseQuote2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCloseQuote2"><Path d="M2 4V14H5V20.443C5.72123 20.1725 6.44369 19.9446 7.11526 19.5669C7.54334 19.3261 8.11266 18.9526 8.68394 18.417C9.83819 17.3349 11 15.5853 11 13V4H2Z" fill="currentColor"/><Path d="M13.0049 4L13 14H16.0011L16.0053 20.4426C16.7263 20.1723 17.4484 19.9445 18.1197 19.5669C18.5477 19.3261 19.1171 18.9526 19.6883 18.417C20.8426 17.3349 22.0044 15.5853 22.0044 13V4H13.0049Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCloseQuote2;
